/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
import store from './store'
import CookieConsentPlugin from './plugins/cookieConsentPlugin';
import { FrameControl } from './models/FrameControl';

// Set config file and theme
import config from '../configs/configs.json';

// Load config file
export const APP_CONFIGS: FrameControl = config;

// Helper to convert hex to rgb
const hexToRgbStr = (hex: string): string => 
    hex.match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i)?.slice(1).map(x => parseInt(x, 16)).join(", ") || "";

// Set CSS variables dynamically
function setCSSVariables(config: FrameControl): void {
    const root = document.documentElement;

    // Update the primary font
    const primaryFont = config.general.display.primaryFont;
    const secondaryFont = config.general.display.secondaryFont;
    const bodyFont = config.general.display.bodyFont;
    const themeColor = config.general.display.themeColor;
    if (primaryFont) root.style.setProperty('--cnvs-primary-font', primaryFont);
    if (secondaryFont) root.style.setProperty('--cnvs-secondary-font', secondaryFont);
    if (bodyFont) root.style.setProperty('--cnvs-body-font', bodyFont);
    if (themeColor) root.style.setProperty('--cnvs-themecolor', themeColor);
    if (themeColor) root.style.setProperty('--cnvs-themecolor-rgb', hexToRgbStr(themeColor));
}

// Apply CSS changes
setCSSVariables(APP_CONFIGS);

// Create head tags for SEO
const head = createHead()

// Create app
createApp(App).use(store).use(router).use(CookieConsentPlugin).use(head).mount('#app');

// Set favicon
function setFavicon(url: string): void {
    const link: HTMLLinkElement = document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = url;
    document.head.appendChild(link);
}
setFavicon(config.assets.faviconImage);
